
import React, { useEffect } from 'react';
import Navbar from '@/components/navbar';
import Footer from '@/components/Footer';
import SEOMetaTags from '@/components/SEOMetaTags';
import { recoverFromBlankScreen } from '@/utils/botx/recovery';
import ThreoAIPricingHeader from '@/components/pricing/threoai/ThreoAIPricingHeader';
import ThreoAIPricingTiers from '@/components/pricing/threoai/ThreoAIPricingTiers';
import ThreoAIPricingFeatureTable from '@/components/pricing/threoai/ThreoAIPricingFeatureTable';
import ThreoAIPricingFAQ from '@/components/pricing/threoai/ThreoAIPricingFAQ';

const ThreoAIPricing = () => {
  useEffect(() => {
    try {
      setTimeout(() => recoverFromBlankScreen(true), 100);
    } catch (error) {
      console.error('Error in ThreoAI Pricing page useEffect:', error);
    }
  }, []);

  const pricingSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "ThreoAI Enterprise Platform Pricing | Synthreo",
    "description": "Explore ThreoAI enterprise platform pricing options for organizations of all sizes. Find the right plan to power your AI transformation.",
    "url": "https://synthreo.ai/pricing",
    "mainEntity": {
      "@type": "Product",
      "name": "ThreoAI Platform",
      "description": "Enterprise-grade AI platform with advanced customization",
      "offers": {
        "@type": "AggregateOffer",
        "priceCurrency": "USD",
        "lowPrice": "17",
        "highPrice": "4999",
        "offerCount": "3"
      },
      "category": "Enterprise AI Platforms",
      "keywords": [
        "ThreoAI pricing", 
        "enterprise AI platform", 
        "AI transformation",
        "branded chat portal", 
        "multi-tenant AI", 
        "AI agent interface"
      ]
    }
  };

  const keywordsList = "ThreoAI pricing, enterprise AI platform, branded chat portal, multi-tenant AI, AI agent interface, enterprise AI deployment";

  return (
    <div className="min-h-screen bg-synthreo-black text-white flex flex-col overflow-hidden">
      <SEOMetaTags 
        title="ThreoAI Enterprise Platform Pricing | Synthreo"
        description="Discover flexible pricing options for ThreoAI, our enterprise-grade AI platform. Choose from startup-friendly to enterprise-scale plans for your AI transformation journey."
        url="https://synthreo.ai/pricing"
        canonical="https://synthreo.ai/pricing"
        keywords={keywordsList}
        schema={pricingSchema}
      />
      <Navbar />
      <main className="flex-grow w-full pt-24">
        <ThreoAIPricingHeader />
        <ThreoAIPricingTiers />
        <ThreoAIPricingFeatureTable />
        <ThreoAIPricingFAQ />
      </main>
      <Footer />
    </div>
  );
};

export default ThreoAIPricing;
